import React, { useEffect, useMemo, useState, useRef } from "react";
import {
    Box,
    Paper,
    CircularProgress,
    Typography,
    Link,
    Stack,
    Divider,
    Button,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Alert,
    TextField,
    Switch,
    Chip,
} from "@mui/material";
import { useAuth } from "../components/TokenHandler";
import ConsentModal from "../components/Consent";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import HistoryIcon from "@mui/icons-material/History";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SendIcon from "@mui/icons-material/Send";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import BatchDownloadPdfsModal from "../consent/modals/BatchDownloadPdfsModal";

const STATUS_TABS = [
    "Pending",
    "Initiated",
    "Opted In",
    "Opted Out",
    "POA Opted In",
    "POA Opted Out",
    "Discharged",
];
const ConsentPatientView = ({
                                filteredPatients = [],
                                patientsLoading = false,
                                facility_unique_id,
                                facility_name,
                                provider_number,
                                fac_id,
                                ouid,
                                ehr_ds,
                            }) => {
    const { keycloak: kc, givenName, familyName, email, roles = [] } = useAuth();


    const canDownloadConsentPdfs =
        roles.includes("admin_role") ||
        roles.includes("consent_role-admin") ||
        roles.includes("consent_role_read_only");

    const canEditConsent =
        roles.includes("admin_role") ||
        roles.includes("consent_role-admin") ||
        roles.includes("consent_role");

    const canManageFacilityGeneralConsent =
        roles.includes("consent_role-admin");

    console.log(kc)

    //console.log(filteredPatients)
    const [fetchAllLoading, setFetchAllLoading] = useState(false);

    const [facilityGeneralConsent, setFacilityGeneralConsent] = useState(false);
    const [facilityGeneralConsentLoading, setFacilityGeneralConsentLoading] = useState(false);
    const [facilityGeneralConsentSaving, setFacilityGeneralConsentSaving] = useState(false);
    const [facilityGeneralConsentError, setFacilityGeneralConsentError] = useState("");

    const [consentLatestById, setConsentLatestById] = useState({});
    const [consentHistoryById, setConsentHistoryById] = useState({});

    const [selectedStatus, setSelectedStatus] = useState("Pending");

    const INITIAL_VISIBLE_COUNT = 30;
    const LOAD_MORE_COUNT = 30;

    const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);

    const loadMoreRef = useRef(null);

    const [consentOpen, setConsentOpen] = useState(false);
    const [consentMode, setConsentMode] = useState("obtain");
    const [consentContext, setConsentContext] = useState(null);

    const [menuAnchorPosition, setMenuAnchorPosition] = useState(null);
    const [menuPatient, setMenuPatient] = useState(null);
    const menuOpen = Boolean(menuAnchorPosition);

    const [historyOpen, setHistoryOpen] = useState(false);
    const [historyPatient, setHistoryPatient] = useState(null);

    const [commOpen, setCommOpen] = useState(false);
    const [commPatient, setCommPatient] = useState(null);
    const [commLoading, setCommLoading] = useState(false);
    const [commError, setCommError] = useState("");
    const [commRows, setCommRows] = useState([]);

    // Front page proxy dialog
    const [proxyInfoOpen, setProxyInfoOpen] = useState(false);
    const [proxyInfoPatient, setProxyInfoPatient] = useState(null);
    const [proxyDialogMode, setProxyDialogMode] = useState("view"); // view | create

    const [proxyFirstName, setProxyFirstName] = useState("");
    const [proxyLastName, setProxyLastName] = useState("");
    const [proxyEmail, setProxyEmail] = useState("");
    const [proxyPhone, setProxyPhone] = useState("");
    const [proxyRelationship, setProxyRelationship] = useState("");

    const [proxyLineCheck, setProxyLineCheck] = useState({
        status: "idle",
        message: "",
        response: null,
    });

    const [proxySaveLoading, setProxySaveLoading] = useState(false);
    const [proxySaveMsg, setProxySaveMsg] = useState({
        open: false,
        severity: "info",
        text: "",
    });

    const proxyDebounceRef = React.useRef(null);
    const proxyLastCheckedRef = React.useRef("");

    // History-row proxy dialog
    const [historyProxyOpen, setHistoryProxyOpen] = useState(false);
    const [historyProxyRow, setHistoryProxyRow] = useState(null);

    const [resendLoading, setResendLoading] = useState(false);
    const [resendMsg, setResendMsg] = useState({ open: false, severity: "success", text: "" });

    const [resetOpen, setResetOpen] = useState(false);
    const [resetPatient, setResetPatient] = useState(null);
    const [resetChoice, setResetChoice] = useState("");
    const [resetLoading, setResetLoading] = useState(false);
    const [resetError, setResetError] = useState("");
    const [resetResult, setResetResult] = useState("");
    const [resetConfirmOpen, setResetConfirmOpen] = useState(false);

    const [initiateProxyConfirmOpen, setInitiateProxyConfirmOpen] = useState(false);
    const [initiateProxyPatient, setInitiateProxyPatient] = useState(null);
    const [batchDownloadPdfsOpen, setBatchDownloadPdfsOpen] = useState(false);
    const [batchDownloadPatientIds, setBatchDownloadPatientIds] = useState([]);

    const norm = (v) => (v ?? "").toString().trim().toLowerCase();
    const hasValue = (v) => String(v ?? "").trim() !== "";
    const digitsOnly = (v) => String(v || "").replace(/\D/g, "");

    const pickFirst = (...vals) => {
        for (const v of vals) {
            if (v === undefined || v === null) continue;
            const s = String(v).trim();
            if (s) return s;
        }
        return "";
    };

    const parseIsoDate = (v) => {
        const t = Date.parse(v);
        return Number.isFinite(t) ? t : 0;
    };

    const getConsentSortTime = (row) => {
        const effective = parseIsoDate(row?.effective_date);
        const updated = parseIsoDate(row?.updated_on);
        const created = parseIsoDate(row?.created_on);

        return {
            effective,
            updated,
            created,
        };
    };


    const compareConsentRows = (a, b) => {
        const aActive = isActiveConsentRow(a) ? 1 : 0;
        const bActive = isActiveConsentRow(b) ? 1 : 0;

        if (aActive !== bActive) return aActive - bActive;

        const ta = getConsentSortTime(a);
        const tb = getConsentSortTime(b);

        if (ta.effective !== tb.effective) return ta.effective - tb.effective;
        if (ta.updated !== tb.updated) return ta.updated - tb.updated;
        if (ta.created !== tb.created) return ta.created - tb.created;

        return 0;
    };

    const fmtDateTime = (v) => {
        const t = parseIsoDate(v);
        if (!t) return "—";
        return new Date(t).toLocaleString();
    };

    const fmtYmd = (v) => {
        const t = Date.parse(v);
        if (!Number.isFinite(t)) return "—";
        return new Date(t).toISOString().slice(0, 10);
    };

    const parseYmdLocalDate = (v) => {
        if (!v) return null;

        const s = String(v).trim();
        const ymd = s.match(/^(\d{4})-(\d{2})-(\d{2})/);

        if (ymd) {
            const year = Number(ymd[1]);
            const month = Number(ymd[2]) - 1;
            const day = Number(ymd[3]);

            const d = new Date(year, month, day);
            return Number.isFinite(d.getTime()) ? d : null;
        }

        const parsed = new Date(s);
        if (!Number.isFinite(parsed.getTime())) return null;

        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    };

    const addDaysLocal = (date, days) => {
        const d = new Date(date);
        d.setDate(d.getDate() + days);
        return d;
    };

    const getTodayLocalDate = () => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    };

    const shouldShowDischargedObtainConsent = (patient) => {
        const dischargeLocal = parseYmdLocalDate(patient?.discharge_date);
        if (!dischargeLocal) return false;

        const todayLocal = getTodayLocalDate();
        const lastEligibleDate = addDaysLocal(dischargeLocal, 14);

        return todayLocal >= dischargeLocal && todayLocal <= lastEligibleDate;
    };

    const getPatientIds = () => {
        return [
            ...new Set(
                filteredPatients
                    .map((p) => String(p?.patient_id ?? "").trim())
                    .filter(Boolean)
            ),
        ];
    };

    const patientHasAnyPdf = (patient) => {
        const rows = Array.isArray(patient?.consent_history_rows)
            ? patient.consent_history_rows
            : [];

        return rows.some((row) => {
            return !!getPdfLocatorFromConsentRow(row);
        });
    };

    const getBatchDownloadPatientIds = () => {
        return [
            ...new Set(
                mergedPatients
                    .filter((patient) => patientHasAnyPdf(patient))
                    .map((patient) => String(patient?.patient_id ?? "").trim())
                    .filter(Boolean)
            ),
        ];
    };

    const openBatchDownloadPdfsModal = () => {
        const patientIds = getBatchDownloadPatientIds();

        setBatchDownloadPatientIds(patientIds);
        setBatchDownloadPdfsOpen(true);
    };

    const closeBatchDownloadPdfsModal = () => {
        setBatchDownloadPdfsOpen(false);
        setBatchDownloadPatientIds([]);
    };

    const escapeCsvValue = (value) => {
        if (value === null || value === undefined) return "";

        const str = String(value);
        if (/[",\n\r]/.test(str)) {
            return `"${str.replace(/"/g, '""')}"`;
        }

        return str;
    };

    const formatCsvDate = (value) => {
        if (!value) return "";
        const parsed = new Date(value);
        if (!Number.isFinite(parsed.getTime())) return String(value);
        return parsed.toISOString().slice(0, 10);
    };

    const downloadPatientConsentsCsv = () => {
        const rows = mergedPatients.filter((patient) => {
            // IMPORTANT: Use the actual derived CONSENT status here, not the
            // page bucket. A patient can be clinically discharged while still
            // having a valid Opted In / Opted Out consent record.
            const consentStatus = norm(patient?.consentStatusLabel);

            // Never include patients whose actual consent status is Pending.
            if (consentStatus === "pending") return false;

            // Only omit an actual Discharged consent when all three consent
            // detail fields are blank. false is a real opt_in_flag value.
            if (consentStatus === "discharged") {
                const consent = patient?.consent_latest || {};
                const consentMethodBlank = !hasValue(consent?.method);
                const optInFlagBlank =
                    consent?.opt_in_flag === null ||
                    consent?.opt_in_flag === undefined ||
                    String(consent?.opt_in_flag).trim() === "";
                const effectiveDateBlank = !hasValue(consent?.effective_date);

                if (consentMethodBlank && optInFlagBlank && effectiveDateBlank) {
                    return false;
                }
            }

            return true;
        });

        const headers = [
            "Patient ID",
            "Patient Unique ID",
            "First Name",
            "Last Name",
            "DOB",
            "Facility Name",
            "Provider Number",
            "Facility Unique ID",
            "Facility MRN",
            "Patient Status",
            "Admission Date",
            "Discharge Date",
            "Consent Status",
            "Consent Method",
            "Opt In Flag",
            "Consent Effective Date",
            "Proxy / POA On File",
            "Proxy First Name",
            "Proxy Last Name",
            "Proxy Relationship",
            "Proxy Email",
            "Proxy Mobile Phone",
            "Proxy Landline",
        ];

        const csvRows = rows.map((patient) => {
            const consent = patient?.consent_latest || {};
            const proxy = getProxyInfoFromLatestConsent(consent) || {};

            return [
                patient?.patient_id,
                patient?.patient_unique_id,
                patient?.first_name,
                patient?.last_name,
                formatCsvDate(patient?.dob),
                patient?.facility_name || facility_name,
                patient?.provider_number || provider_number,
                patient?.facility_unique_id || facility_unique_id,
                patient?.mrn_id,
                patient?.status,
                formatCsvDate(patient?.admission_date),
                formatCsvDate(patient?.discharge_date),
                patient?.consentStatusLabel || "Pending",
                consent?.method,
                consent?.opt_in_flag === true
                    ? "true"
                    : consent?.opt_in_flag === false
                        ? "false"
                        : "",
                formatCsvDate(consent?.effective_date),
                patient?.hasProxyOnFile ? "Yes" : "No",
                proxy?.first_name,
                proxy?.last_name,
                proxy?.relationship,
                proxy?.email,
                proxy?.mobile_phone,
                proxy?.landline,
            ].map(escapeCsvValue).join(",");
        });

        const csv = [headers.map(escapeCsvValue).join(","), ...csvRows].join("\r\n");
        const blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");

        const safeFacilityName = String(facility_name || "patient-consents")
            .trim()
            .replace(/[^a-z0-9_-]+/gi, "_")
            .replace(/^_+|_+$/g, "");

        link.href = url;
        link.download = `${safeFacilityName || "patient-consents"}_patient_consents_${new Date()
            .toISOString()
            .slice(0, 10)}.csv`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const getFacilityGeneralConsentValue = (data) => {
        const candidate =
            (Array.isArray(data) ? data[0] : null) ||
            (Array.isArray(data?.rows) ? data.rows[0] : null) ||
            (Array.isArray(data?.facilities) ? data.facilities[0] : null) ||
            data?.facility ||
            data ||
            null;

        return candidate?.facility_general_consent === true ||
            candidate?.facility_general_consent === "true" ||
            candidate?.facility_general_consent === 1;
    };

    const fetchFacilityGeneralConsent = async () => {
        const facilityId = String(facility_unique_id ?? "").trim();

        if (!facilityId || !kc?.token || !canDownloadConsentPdfs) {
            setFacilityGeneralConsent(false);
            setFacilityGeneralConsentError("");
            return;
        }

        setFacilityGeneralConsentLoading(true);
        setFacilityGeneralConsentError("");

        try {
            const params = new URLSearchParams({
                active: "true",
                facility_unique_id: facilityId,
            });

            const resp = await fetch(
                `${process.env.REACT_APP_API_URL}/consent/facility-consent-details?${params.toString()}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${kc.token}`,
                    },
                }
            );

            const data = await resp.json().catch(() => null);

            if (!resp.ok) {
                throw new Error(
                    data?.message ||
                    data?.error ||
                    `Unable to load facility/general consent status (${resp.status}).`
                );
            }

            setFacilityGeneralConsent(getFacilityGeneralConsentValue(data));
        } catch (e) {
            console.error("Failed to load facility/general consent status:", e);
            setFacilityGeneralConsent(false);
            setFacilityGeneralConsentError(
                e?.message || "Unable to load facility/general consent status."
            );
        } finally {
            setFacilityGeneralConsentLoading(false);
        }
    };

    const handleFacilityGeneralConsentToggle = async (event) => {
        const nextValue = event.target.checked;
        const facilityId = String(facility_unique_id ?? "").trim();

        if (!facilityId || !kc?.token || facilityGeneralConsentSaving) return;

        const previousValue = facilityGeneralConsent;
        setFacilityGeneralConsent(nextValue);
        setFacilityGeneralConsentSaving(true);
        setFacilityGeneralConsentError("");

        try {
            const payload = {
                facilities: [
                    {
                        facility_unique_id: facility_unique_id,
                        facility_name: facility_name || "",
                        facility_general_consent: nextValue,
                        active: nextValue,
                        provider_number: provider_number || "",
                    },
                ],
            };

            const resp = await fetch(
                `${process.env.REACT_APP_API_URL}/consent/facility-consent-details`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${kc.token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const data = await resp.json().catch(() => ({}));

            if (!resp.ok) {
                throw new Error(
                    data?.message ||
                    data?.error ||
                    `Unable to update facility/general consent (${resp.status}).`
                );
            }

            // Re-read the saved value so the switch reflects the server's state.
            await fetchFacilityGeneralConsent();
        } catch (e) {
            console.error("Failed to update facility/general consent:", e);
            setFacilityGeneralConsent(previousValue);
            setFacilityGeneralConsentError(
                e?.message || "Unable to update facility/general consent."
            );
        } finally {
            setFacilityGeneralConsentSaving(false);
        }
    };

    useEffect(() => {
        fetchFacilityGeneralConsent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [facility_unique_id, kc?.token, canDownloadConsentPdfs]);

    const closeResetConfirmDialog = () => {
        setResetConfirmOpen(false);
    };

    const openResetConfirmDialog = () => {
        setResetError("");
        setResetConfirmOpen(true);
    };

    const openHistory = (patient) => {
        setHistoryPatient(patient || null);
        setHistoryOpen(true);
    };

    const closeHistory = () => {
        setHistoryOpen(false);
        setHistoryPatient(null);
    };

    const closeResendMsg = () => setResendMsg({ open: false, severity: "success", text: "" });

    const closeCommHistory = () => {
        setCommOpen(false);
        setCommPatient(null);
        setCommRows([]);
        setCommError("");
        setCommLoading(false);
    };

// ---------- Proxy helpers ----------
    const getProxyInfoFromConsentRow = (consentRow) => {
        if (!consentRow) return null;

        const proxy = consentRow?.proxy;
        if (proxy && typeof proxy === "object") {
            const first_name = String(proxy?.first_name ?? "").trim();
            const last_name = String(proxy?.last_name ?? "").trim();
            const email = String(proxy?.email ?? "").trim();
            const mobile_phone = String(proxy?.mobile_phone ?? "").trim();
            const landline = String(proxy?.landline ?? "").trim();
            const relationship = String(proxy?.relationship ?? "").trim();

            const hasProxyData =
                first_name ||
                last_name ||
                email ||
                mobile_phone ||
                landline ||
                relationship ||
                proxy?.id;

            if (hasProxyData) {
                return {
                    source: "proxy",
                    first_name: first_name || null,
                    last_name: last_name || null,
                    email: email || null,
                    mobile_phone: mobile_phone || null,
                    landline: landline || null,
                    relationship: relationship || null,
                };
            }
        }

        const ef = consentRow?.external_form;
        if (ef && typeof ef === "object") {
            const first_name = String(ef?.ef_proxy_first_name ?? "").trim();
            const last_name = String(ef?.ef_proxy_last_name ?? "").trim();
            const email = String(ef?.ef_proxy_email ?? "").trim();
            const phone_number = String(ef?.ef_proxy_phone_number ?? "").trim();
            const phone_number_type = String(ef?.ef_proxy_phone_number_type ?? "").trim();
            const relationship = String(ef?.ef_proxy_relationship ?? "").trim();

            const hasExternalFormProxyData =
                first_name ||
                last_name ||
                email ||
                phone_number ||
                relationship;

            if (hasExternalFormProxyData) {
                return {
                    source: "external_form",
                    first_name: first_name || null,
                    last_name: last_name || null,
                    email: email || null,
                    mobile_phone: phone_number_type.toLowerCase() === "mobile" ? phone_number || null : null,
                    landline:
                        !phone_number_type || phone_number_type.toLowerCase() !== "mobile"
                            ? phone_number || null
                            : null,
                    relationship: relationship || null,
                    phone_number_type: phone_number_type || null,
                };
            }
        }

        return null;
    };

    const getProxyInfoFromLatestConsent = (latestConsentRow) => {
        return getProxyInfoFromConsentRow(latestConsentRow);
    };

    const hasProxyOnConsentRow = (consentRow) => {
        return !!getProxyInfoFromConsentRow(consentRow);
    };

    const hasProxyOnFile = (latestConsentRow) => {
        return !!getProxyInfoFromLatestConsent(latestConsentRow);
    };

// ---------- Status helpers ----------
    const getConsentStatusLabelFromRow = (row) => {
        if (!row) return "Pending";

        const consent = norm(row?.consent);
        const optInFlag = row?.opt_in_flag;

        const optedInLabels = new Set([
            "opted in",
            "optin",
            "opt in",
        ]);

        const optedOutLabels = new Set([
            "opted out",
            "optout",
            "opt out",
        ]);

        const poaOptedInLabels = new Set([
            "poa opted in",
            "poa optedin",
            "poa opt in",
        ]);

        const poaOptedOutLabels = new Set([
            "poa opted out",
            "poa optedout",
            "poa opt out",
        ]);

        if (optInFlag === true && poaOptedInLabels.has(consent)) {
            return "POA Opted In";
        }

        if (optInFlag === false && poaOptedOutLabels.has(consent)) {
            return "POA Opted Out";
        }

        if (optInFlag === true && optedInLabels.has(consent)) {
            return "Opted In";
        }

        if (optInFlag === false && optedOutLabels.has(consent)) {
            return "Opted Out";
        }

        if (optInFlag === false && consent === "discharged") {
            return "Discharged";
        }

        if (optInFlag == null && consent === "initiated") {
            return "Initiated";
        }

        if (
            optInFlag == null &&
            (consent === "pending" || consent === "pending consent" || consent === "")
        ) {
            return "Pending";
        }

        return "Pending";
    };

    const getPatientConsentEffectiveDate = (consentHistoryRows, latestConsent) => {
        if (!latestConsent) return null;

        const latestStatus = norm(
            getConsentStatusLabelFromRow(latestConsent)
        );

        // For patients who are not opted in, use their
        // current consent record's effective date.
        if (
            latestStatus !== "opted in" &&
            latestStatus !== "poa opted in"
        ) {
            return latestConsent.effective_date || null;
        }

        const rows = (consentHistoryRows || [])
            .filter(
                (row) =>
                    isActiveConsentRow(row) &&
                    row.effective_date &&
                    Number.isFinite(Date.parse(row.effective_date))
            )
            .sort(
                (a, b) =>
                    Date.parse(a.effective_date) -
                    Date.parse(b.effective_date)
            );

        let earliestOptInDate = null;

        for (const row of rows) {
            const status = norm(getConsentStatusLabelFromRow(row));

            const isOptIn =
                status === "opted in" ||
                status === "poa opted in";

            const isOptOut =
                status === "opted out" ||
                status === "poa opted out";

            if (isOptOut) {
                // An Opt Out ends the previous Opt In period.
                earliestOptInDate = null;
            } else if (isOptIn && !earliestOptInDate) {
                // First Opt In after the most recent Opt Out.
                earliestOptInDate = row.effective_date;
            }
        }

        return earliestOptInDate || latestConsent.effective_date || null;
    };

    const EHR_DS_DISCHARGED_STATUSES = new Set([
        "discharged",
        "discharged re",
        "outpatient discharged",
        "outpatient",
        "expired",
        "deleted",
        "inactive",
        "therapeutic leave",
        "hospital leave",
        "unknown",
    ]);

    const NON_EHR_DS_DISCHARGED_STATUSES = new Set([
        "deleted",
        "discharged",
        "inactive",
        "Inactive",
    ]);

    const isPatientDischargedByFilteredPatient = (patient) => {
        const statusNorm = norm(patient?.status);
        const hasDischargeDate = hasValue(patient?.discharge_date);

        if (statusNorm === "deleted") return true;
        if (statusNorm === "inactive") return true;

        if (!hasDischargeDate) return false;

        if (ehr_ds !== null && ehr_ds !== undefined && String(ehr_ds).trim() !== "") {
            return EHR_DS_DISCHARGED_STATUSES.has(statusNorm);
        }

        return NON_EHR_DS_DISCHARGED_STATUSES.has(statusNorm);
    };

    const getStatusAfterErroneousReset = (patient) => {
        const rows = Array.isArray(patient?.consent_history_rows)
            ? patient.consent_history_rows.filter((row) => isActiveConsentRow(row))
            : [];

        if (rows.length <= 1) {
            return "Pending";
        }

        const sorted = [...rows].sort(
            (a, b) =>
                parseIsoDate(b?.updated_on || b?.created_on) -
                parseIsoDate(a?.updated_on || a?.created_on)
        );

        const previousRow = sorted[1];
        return getConsentStatusLabelFromRow(previousRow);
    };

// ---------- PDF helpers ----------
    const getPdfLocatorFromConsentRow = (consentRow) => {
        if (!consentRow) return null;

        const ef = consentRow?.external_form;
        if (ef?.ef_minio_key && ef?.ef_id) {
            return { location: "external_form", id: ef.ef_id };
        }

        if (consentRow?.minio_key && consentRow?.id) {
            return { location: "patient_consent", id: consentRow.id };
        }

        return null;
    };

    const getPdfLocatorFromLatestConsent = (latestConsentRow) => {
        return getPdfLocatorFromConsentRow(latestConsentRow);
    };


    const openInitiateNewProxyConfirm = (patient) => {
        setInitiateProxyPatient(patient || null);
        setInitiateProxyConfirmOpen(true);
    };

    const closeInitiateNewProxyConfirm = () => {
        setInitiateProxyConfirmOpen(false);
        setInitiateProxyPatient(null);
    };

    const confirmInitiateNewProxy = () => {
        const patient = initiateProxyPatient;

        closeInitiateNewProxyConfirm();

        if (!patient) return;

        const latestConsent = patient?.consent_latest || null;

        openConsentModal("obtain", {
            ...patient,
            consent_latest: latestConsent,
            initiatedProxyReplacement: String(latestConsent?.consent || "").toLowerCase() === "initiated",
            previousProxy: latestConsent?.proxy || null,
            previousProxyId: latestConsent?.proxy_id || latestConsent?.proxy?.id || null,
            previousConsentId: latestConsent?.id || null,
        });
    };

    const shouldShowViewConsentForRow = (consentRow) => {
        const consentNorm = norm(getConsentStatusLabelFromRow(consentRow));

        const hasEligibleConsent =
            consentNorm === "opted in" ||
            consentNorm === "opted out" ||
            consentNorm === "poa opted in" ||
            consentNorm === "poa opted out" ||
            consentNorm === "discharged";

        const locator = getPdfLocatorFromConsentRow(consentRow);
        return hasEligibleConsent && !!locator;
    };

    const shouldShowViewConsent = (patient) => {
        return shouldShowViewConsentForRow(patient?.consent_latest);
    };

    const handleViewConsentPdfForRow = async (consentRow) => {
        try {
            const locator = getPdfLocatorFromConsentRow(consentRow);
            if (!locator) return;

            if (!kc?.token) {
                console.error("Missing token, cannot fetch PDF.");
                return;
            }

            const url = `${process.env.REACT_APP_API_URL}/consent/view_patient_consent_pdf/${locator.location}/${locator.id}`;

            const resp = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                },
            });

            if (!resp.ok) {
                console.error("Failed to fetch consent PDF:", resp.status, resp.statusText);
                return;
            }

            const blob = await resp.blob();
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, "_blank", "noopener,noreferrer");
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
        } catch (e) {
            console.error("Error opening consent PDF:", e);
        }
    };

    const handleViewConsentPdf = async (patient) => {
        await handleViewConsentPdfForRow(patient?.consent_latest);
    };

    const formatCommCreatedBy = (value) => {
        if (value == null) return "—";

        const formatObject = (obj) => {
            const givenName = String(obj?.givenName ?? "").trim();
            const familyName = String(obj?.familyName ?? "").trim();
            const email = String(obj?.email ?? "").trim();
            const action = String(obj?.action ?? "").trim();
            const date = String(obj?.date ?? "").trim();

            const hasKnownFields = givenName || familyName || email || action || date;

            if (!hasKnownFields) {
                return typeof obj === "object" ? JSON.stringify(obj) : String(obj);
            }

            const parts = [];

            if (givenName || familyName) {
                const fullName = [givenName, familyName].filter(Boolean).join(" ");
                parts.push(`Name: ${fullName || "—"}`);
            }

            if (action) parts.push(`Action: ${action}`);

            return parts.join(" • ");
        };

        if (typeof value === "object") return formatObject(value);

        if (typeof value === "string") {
            const trimmed = value.trim();
            if (!trimmed) return "—";

            try {
                const parsed = JSON.parse(trimmed);
                if (parsed && typeof parsed === "object") {
                    return formatObject(parsed);
                }
            } catch (_) {
                // ignore
            }

            return trimmed;
        }

        return String(value);
    };

    const openConsentModal = (mode, patient) => {
        const pid = String(patient?.patient_id ?? "").trim();

        // Prefer the consent row already attached to the merged patient object.
        // This preserves proxy/external-form information exactly as it does when
        // Upload New Admission or Verbal Consent is clicked from the Initiated bucket.
        const latestConsent =
            patient?.consent_latest ||
            consentLatestById[pid] ||
            null;

        const facility_name_final =
            (facility_name ?? "").toString().trim() ||
            (patient?.facility_name ?? patient?.facilityName ?? patient?.facility ?? "")
                .toString()
                .trim();

        const provider_number_final =
            (provider_number ?? "").toString().trim() ||
            (patient?.provider_number ?? patient?.providerNumber ?? patient?.facility_number ?? "")
                .toString()
                .trim();

        const created_by = {
            givenName: givenName || "",
            familyName: familyName || "",
            email: email || "",
        };

        setConsentMode(mode);
        const patientWithLatestConsent = {
            ...patient,
            consent_latest: latestConsent,
        };

        setConsentContext({
            patient: patientWithLatestConsent,
            consent_latest: latestConsent,
            facility_name: facility_name_final,
            provider_number: provider_number_final,
            facility_unique_id,
            created_by,

            // Also expose the transition details at the context level in case
            // ConsentModal reads them directly instead of from context.patient.
            consentFlow: patient?.consentFlow || null,
            isOptOut: patient?.isOptOut === true,
            isOptIn: patient?.isOptIn === true,
            previousProxy: patient?.previousProxy || latestConsent?.proxy || null,
            previousProxyId:
                patient?.previousProxyId ||
                latestConsent?.proxy_id ||
                latestConsent?.proxy?.id ||
                null,
            previousConsentId: patient?.previousConsentId || latestConsent?.id || null,
        });

        setConsentOpen(true);
    };

    const closeConsentModal = () => {
        setConsentOpen(false);
        setConsentContext(null);
    };

    const openPatientMenu = (patient) => (e) => {
        e.preventDefault();
        e.stopPropagation();

        setMenuAnchorPosition({
            top: e.clientY,
            left: e.clientX,
        });

        setMenuPatient(patient);
    };

    const closePatientMenu = () => {
        setMenuAnchorPosition(null);
        setMenuPatient(null);
    };

    const handleConsentHistory = (patient) => {
        openHistory(patient);
        closePatientMenu();
    };

    const fetchCommunicationHistory = async (patient_id) => {
        setCommLoading(true);
        setCommError("");
        setCommRows([]);

        try {
            if (!patient_id) {
                setCommError("Missing patient_id.");
                return;
            }
            if (!kc?.token) {
                setCommError("Missing token, cannot fetch communication history.");
                return;
            }

            const url = `${process.env.REACT_APP_API_URL}/consent/communication_history/${encodeURIComponent(
                String(patient_id)
            )}`;

            const resp = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                },
            });

            if (!resp.ok) {
                setCommError(`Failed to fetch communication history: ${resp.status} ${resp.statusText}`);
                return;
            }

            const data = await resp.json();
            const rows = Array.isArray(data?.rows) ? data.rows : [];

            rows.sort((a, b) => parseIsoDate(b?.created_on) - parseIsoDate(a?.created_on));
            setCommRows(rows);
        } catch (e) {
            setCommError(`Error fetching communication history: ${e?.message || e}`);
        } finally {
            setCommLoading(false);
        }
    };

    const handleCommunicationHistory = (patient) => {
        setCommPatient(patient || null);
        setCommOpen(true);
        closePatientMenu();
        fetchCommunicationHistory(patient?.patient_id);
    };

// ---------- Front-page proxy dialog ----------
    const resetProxyDialogState = () => {
        setProxyFirstName("");
        setProxyLastName("");
        setProxyEmail("");
        setProxyPhone("");
        setProxyRelationship("");
        setProxyLineCheck({ status: "idle", message: "", response: null });
        proxyLastCheckedRef.current = "";
        setProxySaveLoading(false);
    };

    const openProxyInfoDialog = (patient, mode = "view") => {
        const latestConsent = patient?.consent_latest || null;
        const info = getProxyInfoFromLatestConsent(latestConsent);

        setProxyInfoPatient(patient || null);
        setProxyDialogMode(mode);

        setProxyFirstName(pickFirst(info?.first_name));
        setProxyLastName(pickFirst(info?.last_name));
        setProxyEmail(pickFirst(info?.email));
        setProxyPhone(digitsOnly(pickFirst(info?.mobile_phone, info?.landline)));
        setProxyRelationship(pickFirst(info?.relationship));

        setProxyLineCheck({ status: "idle", message: "", response: null });
        proxyLastCheckedRef.current = "";
        setProxySaveLoading(false);
        setProxySaveMsg({ open: false, severity: "info", text: "" });

        setProxyInfoOpen(true);
    };

    const closeProxyInfoDialog = () => {
        setProxyInfoOpen(false);
        setProxyInfoPatient(null);
        setProxyDialogMode("view");
        resetProxyDialogState();
    };
    const isActiveConsentRow = (row) => {
        return row?.active === true || row?.active === "true" || row?.active === 1;
    };


    const doProxyLineTypeCheck = async (tenDigits) => {
        if (!kc?.token) {
            setProxyLineCheck({
                status: "error",
                message: "Missing auth token. Cannot verify phone line type.",
                response: null,
            });
            return;
        }

        setProxyLineCheck({
            status: "checking",
            message: "Checking phone line type…",
            response: null,
        });

        try {
            const resp = await fetch(`${process.env.REACT_APP_API_URL}/consent/line-type`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ phone: `+1${tenDigits}` }),
            });

            const data = await resp.json().catch(() => null);

            if (!resp.ok || !data) {
                setProxyLineCheck({
                    status: "error",
                    message: "Line-type check failed.",
                    response: data,
                });
                return;
            }

            const isMobile =
                String(data?.lineType || "").toLowerCase() === "mobile" || data?.isCell === true;

            if (data?.valid && isMobile) {
                setProxyLineCheck({
                    status: "ok",
                    message: `Mobile number confirmed (${data?.nationalFormat || `+1${tenDigits}`}).`,
                    response: data,
                });
            } else if (data?.valid) {
                setProxyLineCheck({
                    status: "bad",
                    message: `This number is not mobile (line type: ${data?.lineType || "unknown"}).`,
                    response: data,
                });
            } else {
                setProxyLineCheck({
                    status: "bad",
                    message: "Phone number is not valid.",
                    response: data,
                });
            }
        } catch {
            setProxyLineCheck({
                status: "error",
                message: "Unable to check phone line type (network/server error).",
                response: null,
            });
        }
    };

    useEffect(() => {
        if (!proxyInfoOpen) return;
        if (proxyDialogMode !== "create") return;

        const digits = digitsOnly(proxyPhone);

        if (proxyDebounceRef.current) clearTimeout(proxyDebounceRef.current);

        if (digits.length !== 10) {
            if (proxyLastCheckedRef.current) {
                setProxyLineCheck({ status: "idle", message: "", response: null });
                proxyLastCheckedRef.current = "";
            }
            return;
        }

        proxyDebounceRef.current = setTimeout(() => {
            if (proxyLastCheckedRef.current === digits) return;
            proxyLastCheckedRef.current = digits;
            doProxyLineTypeCheck(digits);
        }, 900);

        return () => {
            if (proxyDebounceRef.current) clearTimeout(proxyDebounceRef.current);
        };
    }, [proxyPhone, proxyInfoOpen, proxyDialogMode]);

    const handleSaveProxyInfo = async () => {
        const latestConsentId = String(proxyInfoPatient?.consent_latest?.id ?? "").trim();
        const patientId = String(proxyInfoPatient?.patient_id ?? "").trim();
        const digits = digitsOnly(proxyPhone);

        if (!latestConsentId) {
            setProxySaveMsg({
                open: true,
                severity: "error",
                text: "Missing latest consent record id.",
            });
            return;
        }

        if (!patientId) {
            setProxySaveMsg({
                open: true,
                severity: "error",
                text: "Missing patient id.",
            });
            return;
        }

        if (digits.length === 10 && proxyLineCheck.status === "checking") {
            return;
        }

        if (digits.length === 10 && proxyLineCheck.status === "bad" && proxyLineCheck.response?.valid === false) {
            setProxySaveMsg({
                open: true,
                severity: "error",
                text: "Phone number is not valid. Please correct it before saving.",
            });
            return;
        }

        if (!kc?.token) {
            setProxySaveMsg({
                open: true,
                severity: "error",
                text: "Missing token, cannot save proxy contact information.",
            });
            return;
        }

        setProxySaveLoading(true);

        try {
            const payload = {
                id: latestConsentId,
                patient_id: patientId,
                proxy: {
                    firstName: proxyFirstName,
                    lastName: proxyLastName,
                    email: proxyEmail,
                    phone: proxyPhone ? `+1${digitsOnly(proxyPhone)}` : "",
                    relationship: proxyRelationship,
                    lineTypeResponse: proxyLineCheck.response,
                    sms_capable: proxyLineCheck.status === "ok",
                    line_type: String(proxyLineCheck.response?.lineType || ""),
                },
                created_by: {
                    givenName: givenName || "",
                    familyName: familyName || "",
                    email: email || "",
                    date: new Date().toISOString(),
                    action: "add proxy contact information",
                },
            };

            const resp = await fetch(`${process.env.REACT_APP_API_URL}/consent/add_proxy`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await resp.json().catch(() => ({}));

            if (!resp.ok) {
                setProxySaveMsg({
                    open: true,
                    severity: "error",
                    text: data?.error || data?.message || `Add proxy failed: ${resp.status} ${resp.statusText}`,
                });
                return;
            }

            setProxySaveMsg({
                open: true,
                severity: "success",
                text: "Proxy contact information added successfully.",
            });

            await fetchAll();
            closeProxyInfoDialog();
        } catch (e) {
            setProxySaveMsg({
                open: true,
                severity: "error",
                text: e?.message || "Unable to save proxy contact information.",
            });
        } finally {
            setProxySaveLoading(false);
        }
    };

// ---------- History-row proxy dialog ----------
    const openHistoryProxyDialog = (consentRow) => {
        setHistoryProxyRow(consentRow || null);
        setHistoryProxyOpen(true);
    };

    const closeHistoryProxyDialog = () => {
        setHistoryProxyOpen(false);
        setHistoryProxyRow(null);
    };

    const handleResetConsentStatus = (patient) => {
        setResetPatient(patient || null);
        setResetChoice("");
        setResetError("");
        setResetResult("");
        setResetLoading(false);
        setResetOpen(true);
        closePatientMenu();
    };

    const closeResetDialog = () => {
        setResetOpen(false);
        setResetConfirmOpen(false);
        setResetPatient(null);
        setResetChoice("");
        setResetError("");
        setResetResult("");
        setResetLoading(false);
    };

    const openResetConsentModal = (mode) => {
        const patient = resetPatient;

        if (!patient) {
            setResetError("Missing patient information.");
            return;
        }

        const latestConsent = patient?.consent_latest || null;
        const isCurrentlyOptedIn = latestConsent?.opt_in_flag === true;
        const consentFlow = isCurrentlyOptedIn ? "opt_out" : "opt_in";

        // Preserve the same merged patient/proxy context used by the
        // Upload New Admission and Verbal Consent buttons in the Initiated bucket.
        const consentPatient = {
            ...patient,
            consent_latest: latestConsent,
            consentFlow,
            isOptOut: consentFlow === "opt_out",
            isOptIn: consentFlow === "opt_in",
            previousProxy: latestConsent?.proxy || null,
            previousProxyId: latestConsent?.proxy_id || latestConsent?.proxy?.id || null,
            previousConsentId: latestConsent?.id || null,
        };

        // Open ConsentModal with the exact merged patient object first, then
        // clear the reset dialog state. The local object retains all proxy data.
        openConsentModal(mode, consentPatient);
        setResetOpen(false);
        setResetConfirmOpen(false);
        setResetPatient(null);
        setResetChoice("");
        setResetError("");
        setResetResult("");
        setResetLoading(false);
    };

    const submitResetConsent = async () => {
        const consentId = String(resetPatient?.consent_latest?.id ?? "").trim();

        if (!consentId) {
            setResetError("Missing consent record id.");
            setResetConfirmOpen(false);
            return;
        }

        if (resetChoice !== "erroneous") {
            setResetError("Please choose the archive option to continue.");
            setResetConfirmOpen(false);
            return;
        }

        if (!kc?.token) {
            setResetError("Missing token, cannot reset consent.");
            setResetConfirmOpen(false);
            return;
        }

        const patientHasProxy = hasProxyOnConsentRow(resetPatient?.consent_latest);

        const payload = {
            id: consentId,
            mode: "erroneous",
            reason: "archived consent",
            patient_has_proxy: patientHasProxy,
            created_by: {
                date: new Date().toISOString(),
                email: email || "",
                action: "archived - consent reversal",
                givenName: givenName || "",
                familyName: familyName || "",
            },
        };

        setResetLoading(true);
        setResetError("");
        setResetResult("");
        setResetConfirmOpen(false);

        try {
            const url = `${process.env.REACT_APP_API_URL}/consent/reset_consent`;

            const resp = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await resp.json().catch(() => ({}));

            if (!resp.ok) {
                setResetError(
                    data?.message || data?.error || `Reset failed: ${resp.status} ${resp.statusText}`
                );
                return;
            }

            setResetResult(data?.message || "Consent status updated successfully.");
            await fetchAll();
        } catch (e) {
            setResetError(`Reset error: ${e?.message || String(e)}`);
        } finally {
            setResetLoading(false);
        }
    };

    const handleConsentSuccess = async () => {
        await fetchAll();
    };

    const handleResendConsentMessage = async (patient) => {
        const proxyInfo = getProxyInfoFromLatestConsent(patient?.consent_latest);

        const payload = {
            patient_id: String(patient?.patient_id ?? "").trim(),
            sms: proxyInfo?.mobile_phone || "",
            email: proxyInfo?.email || "",
            facility_name: facility_name,
            provider_number: provider_number,
            created_by: {
                givenName: givenName || "",
                familyName: familyName || "",
                email: email || "",
                date: new Date().toISOString(),
                action: "reinitiate consent",
            },
        };

        closePatientMenu();

        if (!payload.patient_id) {
            setResendMsg({ open: true, severity: "error", text: "Missing patient_id." });
            return;
        }
        if (!payload.sms && !payload.email) {
            setResendMsg({
                open: true,
                severity: "error",
                text: "Proxy/POA is missing both mobile phone and email. Cannot resend.",
            });
            return;
        }
        if (!kc?.token) {
            setResendMsg({ open: true, severity: "error", text: "Missing token, cannot resend." });
            return;
        }

        setResendLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URL}/consent/resend_consent`;

            const resp = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await resp.json().catch(() => ({}));

            if (!resp.ok) {
                setResendMsg({
                    open: true,
                    severity: "error",
                    text: data?.message || data?.error || `Resend failed: ${resp.status} ${resp.statusText}`,
                });
                return;
            }

            setResendMsg({
                open: true,
                severity: "success",
                text: data?.message || "Resend processed.",
            });
        } catch (e) {
            setResendMsg({
                open: true,
                severity: "error",
                text: `Resend error: ${e?.message || String(e)}`,
            });
        } finally {
            setResendLoading(false);
        }
    };

    const fetchConsentLatest = async (patientIds) => {
        try {
            if (patientIds.length === 0) {
                setConsentLatestById({});
                setConsentHistoryById({});
                return;
            }
            if (!kc?.token) {
                setConsentLatestById({});
                setConsentHistoryById({});
                return;
            }

            const resp = await fetch(`${process.env.REACT_APP_API_URL}/consent/view_patient_consent`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${kc.token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ patient_ids: patientIds }),
            });

            if (!resp.ok) {
                console.error("Failed to fetch view_patient_consent:", resp.statusText);
                setConsentLatestById({});
                setConsentHistoryById({});
                return;
            }

            const data = await resp.json();

            const latestById = {};
            const historyById = {};

            for (const row of data?.rows || []) {
                const pid = String(row?.patient_id ?? "").trim();
                if (!pid) continue;

                if (!historyById[pid]) historyById[pid] = [];
                historyById[pid].push(row);

                if (!isActiveConsentRow(row)) continue;

                const existing = latestById[pid];

                if (!existing || compareConsentRows(row, existing) > 0) {
                    latestById[pid] = row;
                }
            }

            Object.keys(historyById).forEach((pid) => {
                historyById[pid].sort((a, b) => compareConsentRows(b, a));
            });

            setConsentLatestById(latestById);
            setConsentHistoryById(historyById);
        } catch (e) {
            console.error("Error fetching view_patient_consent:", e);
            setConsentLatestById({});
            setConsentHistoryById({});
        }
    };

    const loading = patientsLoading;

    const fetchAll = async () => {
        setFetchAllLoading(true);
        try {
            const patientIds = getPatientIds();
            await fetchConsentLatest(patientIds);
        } finally {
            setFetchAllLoading(false);
        }
    };

    useEffect(() => {
        fetchAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredPatients, kc?.token, facility_unique_id]);

    const mergedPatients = useMemo(() => {
        return filteredPatients.map((p) => {
            const pid = String(p?.patient_id ?? "").trim();
            const latestConsent = consentLatestById[pid] || null;
            const consentHistoryRows = consentHistoryById[pid] || [];
            const consentStatusLabel = getConsentStatusLabelFromRow(latestConsent);
            const dischargedByFilteredPatient = isPatientDischargedByFilteredPatient(p);
            const proxyInfo = getProxyInfoFromLatestConsent(latestConsent);

            return {
                ...p,
                consent_latest: latestConsent,
                consent_history_rows: consentHistoryRows,
                consentStatusLabel,
                dischargedByFilteredPatient,
                proxyInfo,
                hasProxyOnFile: !!proxyInfo,
                consentEffectiveDate: getPatientConsentEffectiveDate(
                    consentHistoryRows,
                    latestConsent
                ),
            };
        });
    }, [filteredPatients, consentLatestById, consentHistoryById]);

    const tabForPatient = (p) => {
        if (!p) return "Pending";

        if (p.dischargedByFilteredPatient) return "Discharged";

        const s = norm(p.consentStatusLabel);

        if (s === "opted in") return "Opted In";
        if (s === "opted out") return "Opted Out";
        if (s === "poa opted in") return "POA Opted In";
        if (s === "poa opted out") return "POA Opted Out";
        if (s === "initiated") return "Initiated";
        if (s === "discharged") return "Discharged";

        return "Pending";
    };

    const bucketCounts = useMemo(() => {
        const counts = STATUS_TABS.reduce((acc, label) => {
            acc[label] = 0;
            return acc;
        }, {});

        mergedPatients.forEach((patient) => {
            const tab = tabForPatient(patient);
            counts[tab] = (counts[tab] || 0) + 1;
        });

        return counts;
    }, [mergedPatients]);

    const visiblePatients = useMemo(() => {
        const sel = norm(selectedStatus);
        return mergedPatients.filter((p) => norm(tabForPatient(p)) === sel);
    }, [mergedPatients, selectedStatus]);

    const displayedPatients = useMemo(() => {
        return visiblePatients.slice(0, visibleCount);
    }, [visiblePatients, visibleCount]);

    const hasMorePatients = visibleCount < visiblePatients.length;


    useEffect(() => {
        const target = loadMoreRef.current;

        if (!target || !hasMorePatients) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];

                if (!entry?.isIntersecting) {
                    return;
                }

                setVisibleCount((current) =>
                    Math.min(
                        current + LOAD_MORE_COUNT,
                        visiblePatients.length
                    )
                );
            },
            {
                root: null,
                rootMargin: "500px 0px",
                threshold: 0,
            }
        );

        observer.observe(target);

        return () => {
            observer.disconnect();
        };
    }, [hasMorePatients, visiblePatients.length]);

//console.log(visiblePatients)

    const getToneForStatus = (tabLabel) => {
        const s = norm(tabLabel);

        if (s === "opted in") return "good";
        if (s === "poa opted in") return "good";

        if (s === "opted out") return "bad";
        if (s === "poa opted out") return "bad";

        if (s === "initiated") return "warn";
        if (s === "discharged") return "bad";

        return "none";
    };

    const getCardBorder = (tone) => {
        if (tone === "good") return "2px solid #2e7d32";
        if (tone === "bad") return "2px solid #c62828";
        if (tone === "warn") return "2px solid #ed6c02";
        return "1px solid #ddd";
    };

    const getCardBg = (tone) => {
        if (tone === "good") return "#f1fbf3";
        if (tone === "bad") return "#fff3f3";
        if (tone === "warn") return "#fff8e6";
        return "#ffffff";
    };

    const isFacilityGeneralOptedIn = (patient) => {
        const latestConsent = patient?.consent_latest;
        const currentStatus = norm(patient?.consentStatusLabel);

        // Allow both regular and POA Opted In statuses.
        if (
            !["opted in", "poa opted in"].includes(currentStatus) ||
            !isActiveConsentRow(latestConsent) ||
            latestConsent?.opt_in_flag !== true
        ) {
            return false;
        }

        // Only active Opt In records count.
        const activeOptIns = (patient?.consent_history_rows || [])
            .filter((row) => {
                if (!isActiveConsentRow(row)) return false;

                const status = norm(getConsentStatusLabelFromRow(row));

                return (
                    status === "opted in" ||
                    status === "poa opted in"
                );
            });

        const isFacilityGeneral = (row) => {
            const method = norm(row?.method)
                .replace(/\s*\/\s*/g, "/");

            return method.includes("facility/general");
        };

        const hasFacilityGeneralOptIn =
            activeOptIns.some(isFacilityGeneral);

        const hasOtherActiveOptIn =
            activeOptIns.some((row) => !isFacilityGeneral(row));

        return hasFacilityGeneralOptIn && !hasOtherActiveOptIn;
    };

    const showConsentActions =
        canEditConsent &&
        [
            "pending",
            "initiated",
            "discharged",
            "opted in",
            "poa opted in",
        ].includes(norm(selectedStatus));

    const menuTab = tabForPatient(menuPatient);
    const showMenuResend = norm(menuTab) === "initiated";
    const showMenuReset = norm(menuTab) !== "pending";
    const menuHasProxyOnFile = !!menuPatient?.hasProxyOnFile;
    const menuLatestConsentId = String(menuPatient?.consent_latest?.id ?? "").trim();

    const showMenuAddProxy =
        norm(menuTab) !== "pending" &&
        !menuHasProxyOnFile &&
        !!menuLatestConsentId;

    const consentHistoryEntries = useMemo(() => {
        const rows = Array.isArray(historyPatient?.consent_history_rows)
            ? historyPatient.consent_history_rows
            : [];

        return rows.map((row, idx) => {
            const createdByRaw = row?.created_by;

            const createdByEntries = Array.isArray(createdByRaw)
                ? createdByRaw
                : createdByRaw && typeof createdByRaw === "object"
                    ? [createdByRaw]
                    : [];

            return {
                row,
                isArchived: !isActiveConsentRow(row),
                createdByEntries: createdByEntries.sort(
                    (a, b) => parseIsoDate(a?.date) - parseIsoDate(b?.date)
                ),
                idx,
            };
        });
    }, [historyPatient]);

    const resetHistoryCount = Array.isArray(resetPatient?.consent_history_rows)
        ? resetPatient.consent_history_rows.length
        : 0;

    const erroneousResetNextStatus = getStatusAfterErroneousReset(resetPatient);

    const resetLatestOptInFlag = resetPatient?.consent_latest?.opt_in_flag;
    const resetConsentDirection = resetLatestOptInFlag === true ? "opt-out" : "opt-in";
    const resetConsentQuestion =
        resetLatestOptInFlag === true
            ? "Is the patient/proxy opting out of all services?"
            : "Is the patient/proxy opting into all services?";

    const shouldShowDischargedConsentActions = (patient) => {
        return patient?.consent_latest?.opt_in_flag == null;
    };

    const historyProxyInfo = getProxyInfoFromConsentRow(historyProxyRow);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Paper
                elevation={0}
                sx={{
                    mx: 2,
                    mt: 2,
                    p: 1.5,
                    border: "1px solid #eee",
                    borderRadius: 2,
                    backgroundColor: "#fafafa",
                }}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    sx={{
                        gap: 1,
                        rowGap: 1,
                    }}
                >
                    {STATUS_TABS.map((label, index) => {
                        const active = norm(label) === norm(selectedStatus);

                        const showDividerAfter =
                            label === "Initiated" ||
                            label === "Opted Out" ||
                            label === "POA Opted Out";

                        return (
                            <React.Fragment key={label}>
                                <Link
                                    component="button"
                                    underline="none"
                                    onClick={() => {
                                        setSelectedStatus(label);
                                        setVisibleCount(INITIAL_VISIBLE_COUNT);
                                    }}
                                    sx={{
                                        fontWeight: active ? 800 : 600,
                                        color: active
                                            ? "primary.main"
                                            : "text.primary",
                                        cursor: "pointer",
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1.5,
                                        backgroundColor: active
                                            ? "rgba(25, 118, 210, 0.08)"
                                            : "transparent",
                                        "&:hover": {
                                            backgroundColor:
                                                "rgba(25, 118, 210, 0.06)",
                                            textDecoration: "none",
                                        },
                                    }}
                                >
                                    {label} ({bucketCounts[label] || 0})
                                </Link>

                                {showDividerAfter &&
                                    index < STATUS_TABS.length - 1 && (
                                        <Divider
                                            orientation="vertical"
                                            flexItem
                                            sx={{
                                                mx: 0.5,
                                                borderColor: "#d0d7de",
                                            }}
                                        />
                                    )}
                            </React.Fragment>
                        );
                    })}

                    <Box sx={{ flexGrow: 1 }} />

                    {canManageFacilityGeneralConsent && (
                        <Tooltip
                            title={
                                facilityGeneralConsentError ||
                                "Turn facility/general consent on or off for this facility"
                            }
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.5}
                                sx={{ mr: 0.5 }}
                            >
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: "0.85rem",
                                        fontWeight: 600,
                                        color: facilityGeneralConsentError
                                            ? "error.main"
                                            : "text.secondary",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Facility / General Consent
                                </Typography>

                                {facilityGeneralConsentLoading ? (
                                    <CircularProgress
                                        size={20}
                                        sx={{ mx: 1 }}
                                    />
                                ) : (
                                    <Switch
                                        size="small"
                                        checked={facilityGeneralConsent}
                                        onChange={
                                            handleFacilityGeneralConsentToggle
                                        }
                                        disabled={
                                            facilityGeneralConsentSaving ||
                                            !facility_unique_id ||
                                            !kc?.token
                                        }
                                        inputProps={{
                                            "aria-label":
                                                "Facility / General Consent",
                                        }}
                                    />
                                )}
                            </Stack>
                        </Tooltip>
                    )}

                    {canDownloadConsentPdfs && (
                        <>
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={downloadPatientConsentsCsv}
                            >
                                Download CSV
                            </Button>

                            <Button
                                size="small"
                                variant="contained"
                                onClick={openBatchDownloadPdfsModal}
                            >
                                Download PDFs
                            </Button>
                        </>
                    )}
                </Stack>
            </Paper>

            {fetchAllLoading && (
                <Box sx={{ px: 2, pt: 1 }}>
                    <Typography sx={{ fontSize: "0.85rem", color: "text.secondary" }}>
                        Refreshing consent data...
                    </Typography>
                </Box>
            )}

            <Divider sx={{ my: 2, mx: 2 }} />

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, px: 2, pb: 2 }}>
                {displayedPatients.map((patient) => {
                    const tabLabel = tabForPatient(patient);
                    const tone = getToneForStatus(tabLabel);
                    const patientTabNorm = norm(tabLabel);

                    return (
                        <Paper
                            key={patient.patient_id}
                            elevation={2}
                            sx={{
                                width: "100%",
                                p: 2,
                                border: getCardBorder(tone),
                                backgroundColor: getCardBg(tone),
                            }}
                        >
                            <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
                                <Box>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}
                                        flexWrap="wrap"
                                        useFlexGap
                                    >
                                        <Typography sx={{ fontWeight: 700, fontSize: "20px" }}>
                                            {patient.first_name} {patient.last_name}
                                        </Typography>

                                        {(patient.consent_history_rows?.length || 0) > 1 && (
                                            <Tooltip title="Click to view all consent records, including archived records">
                                                <Chip
                                                    icon={<HistoryIcon />}
                                                    label={`Multiple Consents (${patient.consent_history_rows.length})`}
                                                    size="small"
                                                    color="warning"
                                                    variant="outlined"
                                                    clickable
                                                    onClick={() => openHistory(patient)}
                                                    sx={{
                                                        fontWeight: 700,
                                                        backgroundColor: "#fff3e0",
                                                        borderColor: "#ed6c02",
                                                        "&:hover": {
                                                            backgroundColor: "#ffe0b2",
                                                        },
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                    </Stack>

                                    <Typography
                                        sx={{
                                            mt: 0.5,
                                            color: "text.secondary",
                                            fontSize: "0.98rem",
                                        }}
                                    >
                                        Patient Status: {patient.status || "N/A"}
                                    </Typography>
                                </Box>

                                {canEditConsent && norm(tabLabel) !== "pending" && (
                                    <Tooltip title="Actions">
                                        <IconButton
                                            size="small"
                                            onClick={openPatientMenu(patient)}
                                            sx={{ mt: -0.5, mr: -0.5, borderRadius: 2 }}
                                        >
                                            <MoreVertIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Stack>

                            <Divider sx={{ my: 1.5 }} />

                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                                    gap: 2,
                                }}
                            >
                                <Box>
                                    <Typography sx={{ fontWeight: 700, mb: 0.75 }}>Patient Details</Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        DOB: {patient.dob || "—"}
                                    </Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        Admission Date: {fmtYmd(patient.admission_date)}
                                    </Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        Facility MRN: {patient.mrn_id || "—"}
                                    </Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        Internal Patient ID: {patient.patient_id || "—"}
                                    </Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        Location: {patient.location || "—"}
                                    </Typography>

                                    {patient?.discharge_date ? (
                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Discharge Date: {fmtYmd(patient.discharge_date)}
                                        </Typography>
                                    ) : null}
                                </Box>

                                <Box>
                                    <Typography sx={{ fontWeight: 700, mb: 0.75 }}>Consent Details</Typography>

                                    <Typography sx={{ fontSize: "0.92rem", fontWeight: 700 }}>
                                        Consent Status: {patient.consentStatusLabel}
                                    </Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        {patientTabNorm === "initiated" ? "Initiated Date" : "Consent Effective Date"}:{" "}
                                        {fmtYmd(patient.consentEffectiveDate)}
                                    </Typography>

                                    <Typography sx={{ fontSize: "0.92rem" }}>
                                        Proxy / POA on File: {patient.hasProxyOnFile ? "Yes" : "No"}
                                    </Typography>

                                    {(facility_name || provider_number) && (
                                        <Typography sx={{ fontSize: "0.92rem", color: "text.secondary" }}>
                                            {facility_name || "—"}
                                            {provider_number ? (
                                                <>
                                                    {` • Provider #: ${provider_number}`}
                                                    <br />
                                                </>
                                            ) : null}
                                            {facility_unique_id ? `Facility Unique ID #: ${facility_unique_id}` : ""}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 2 }}>
                                {patientTabNorm !== "pending" && patient.hasProxyOnFile && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => openProxyInfoDialog(patient, "view")}
                                    >
                                        View Proxy / POA Contact
                                    </Button>
                                )}

                                {shouldShowViewConsent(patient) && (
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => handleViewConsentPdf(patient)}
                                    >
                                        View Consent
                                    </Button>
                                )}
                            </Stack>

                            {showConsentActions && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "flex-end",
                                        mt: 2,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {patientTabNorm === "pending" && (
                                        <>
                                            <Button size="small" onClick={() => openConsentModal("obtain", patient)}>
                                                Obtain Consent
                                            </Button>

                                            <Button size="small" onClick={() => openConsentModal("upload", patient)}>
                                                Upload New Admission
                                            </Button>

                                            <Button size="small" onClick={() => openConsentModal("verbal", patient)}>
                                                Verbal Consent
                                            </Button>
                                        </>
                                    )}

                                    {patientTabNorm === "initiated" && (
                                        <>
                                            <Button
                                                size="small"
                                                onClick={() => openInitiateNewProxyConfirm(patient)}
                                            >
                                                Initiate New Proxy
                                            </Button>

                                            <Button size="small" onClick={() => openConsentModal("upload", patient)}>
                                                Upload New Admission
                                            </Button>

                                            <Button size="small" onClick={() => openConsentModal("verbal", patient)}>
                                                Verbal Consent
                                            </Button>
                                        </>
                                    )}

                                    {["opted in", "poa opted in"].includes(patientTabNorm) &&
                                        isFacilityGeneralOptedIn(patient) && (
                                            <>
                                                <Button
                                                    size="small"
                                                    onClick={() => openConsentModal("upload", patient)}
                                                >
                                                    Upload New Admission
                                                </Button>

                                                <Button
                                                    size="small"
                                                    onClick={() => openConsentModal("verbal", patient)}
                                                >
                                                    Verbal Consent
                                                </Button>
                                            </>
                                        )}

                                    {patientTabNorm === "discharged" && shouldShowDischargedConsentActions(patient) && (
                                        <>
                                            <Button
                                                size="small"
                                                onClick={() => openConsentModal("upload", patient)}
                                            >
                                                Upload New Admission
                                            </Button>

                                            <Button
                                                size="small"
                                                onClick={() => openConsentModal("verbal", patient)}
                                            >
                                                Verbal Consent
                                            </Button>
                                        </>
                                    )}
                                </Box>
                            )}
                        </Paper>
                    );
                })}

                {hasMorePatients && (
                    <Box
                        ref={loadMoreRef}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            py: 3,
                            gap: 1,
                        }}
                    >
                        <CircularProgress size={28} />

                        <Typography
                            variant="body2"
                            color="text.secondary"
                        >
                            Loading more patients...
                        </Typography>
                    </Box>
                )}

                {!hasMorePatients && visiblePatients.length > 0 && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            textAlign: "center",
                            py: 3,
                        }}
                    >
                        Showing all {visiblePatients.length} patients
                    </Typography>
                )}

                {visiblePatients.length === 0 && (
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            border: "1px dashed #ccc",
                            backgroundColor: "#fafafa",
                        }}
                    >
                        <Typography>No patients found.</Typography>
                    </Paper>
                )}
            </Box>

            <Menu
                anchorReference="anchorPosition"
                anchorPosition={menuAnchorPosition}
                open={menuOpen}
                onClose={closePatientMenu}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: {
                        mt: 1,
                        borderRadius: 2,
                        minWidth: 280,
                        boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                    },
                }}
            >
                <MenuItem onClick={() => handleConsentHistory(menuPatient)}>
                    <ListItemIcon>
                        <HistoryIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Consent history" />
                </MenuItem>

                <MenuItem onClick={() => handleCommunicationHistory(menuPatient)}>
                    <ListItemIcon>
                        <ChatBubbleOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Communication history" />
                </MenuItem>

                {showMenuAddProxy && (
                    <MenuItem
                        onClick={() => {
                            if (!menuPatient?.consent_latest?.id) {
                                closePatientMenu();
                                return;
                            }
                            openProxyInfoDialog(menuPatient, "create");
                            closePatientMenu();
                        }}
                    >
                        <ListItemIcon>
                            <PersonAddAlt1Icon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Add Proxy Contact Information" />
                    </MenuItem>
                )}

                {showMenuReset && (
                    <MenuItem onClick={() => handleResetConsentStatus(menuPatient)}>
                        <ListItemIcon>
                            <RestartAltIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Reset consent status" />
                    </MenuItem>
                )}

                {showMenuResend && (
                    <MenuItem onClick={() => handleResendConsentMessage(menuPatient)}>
                        <ListItemIcon>
                            <SendIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={resendLoading ? "Resending..." : "Resend consent message"} />
                    </MenuItem>
                )}
            </Menu>

            <Dialog open={historyOpen} onClose={closeHistory} fullWidth maxWidth="md">
                <DialogTitle>
                    Consent History
                    {historyPatient?.first_name && historyPatient?.last_name
                        ? ` • ${historyPatient.first_name} ${historyPatient.last_name}`
                        : ""}
                </DialogTitle>

                <DialogContent dividers>
                    {consentHistoryEntries.length === 0 ? (
                        <Typography color="text.secondary">No consent history entries found.</Typography>
                    ) : (
                        <Stack spacing={2}>
                            {consentHistoryEntries.map(({ row, isArchived, createdByEntries, idx }) => (
                                <Paper
                                    key={row?.id || `${row?.patient_id || "x"}-${idx}`}
                                    elevation={0}
                                    sx={{
                                        p: 1.5,
                                        border: isArchived ? "1px solid #f0a58f" : "1px solid #eee",
                                        borderRadius: 2,
                                        backgroundColor: isArchived ? "#dbdbdb" : "#fafafa",
                                    }}
                                >
                                    <Stack spacing={0.5}>
                                        <Typography sx={{ fontWeight: 700 }}>
                                            Consent: {row?.consent || "—"}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                fontSize: "0.92rem",
                                                fontWeight: 700,
                                                color: isArchived ? "#8a3b12" : "#1f4f99",
                                            }}
                                        >
                                            {isActiveConsentRow(row)
                                                ? "Current / Active Record"
                                                : "Archived / Inactive Record"}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Opt In Flag:{" "}
                                            {row?.opt_in_flag === true
                                                ? "true"
                                                : row?.opt_in_flag === false
                                                    ? "false"
                                                    : "null"}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Derived Status: {getConsentStatusLabelFromRow(row)}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Method: {row?.method || "—"}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Consent Effective Date: {fmtYmd(row?.effective_date)}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Proxy / POA on File: {hasProxyOnConsentRow(row) ? "Yes" : "No"}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Record Created: {fmtDateTime(row?.created_on)}
                                        </Typography>

                                        <Typography sx={{ fontSize: "0.92rem" }}>
                                            Record Updated: {fmtDateTime(row?.updated_on)}
                                        </Typography>

                                        {row?.reason_for_opt_out ? (
                                            <Typography sx={{ fontSize: "0.92rem" }}>
                                                Reason for Opt Out: {row.reason_for_opt_out}
                                            </Typography>
                                        ) : null}
                                    </Stack>

                                    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1.5 }}>
                                        {hasProxyOnConsentRow(row) && (
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => openHistoryProxyDialog(row)}
                                            >
                                                View Proxy / POA Contact
                                            </Button>
                                        )}

                                        {shouldShowViewConsentForRow(row) && (
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={() => handleViewConsentPdfForRow(row)}
                                            >
                                                View Consent
                                            </Button>
                                        )}
                                    </Stack>

                                    <Divider sx={{ my: 1.25 }} />

                                    {createdByEntries.length === 0 ? (
                                        <Typography color="text.secondary" sx={{ fontSize: "0.9rem" }}>
                                            No created_by history found for this record.
                                        </Typography>
                                    ) : (
                                        <Stack spacing={1}>
                                            {createdByEntries.map((e, subIdx) => (
                                                <Box
                                                    key={`${row?.id || idx}-${e?.date || "x"}-${subIdx}`}
                                                    sx={{
                                                        p: 1,
                                                        border: "1px solid #e6e6e6",
                                                        borderRadius: 1.5,
                                                        backgroundColor: "#fff",
                                                    }}
                                                >
                                                    <Stack direction="row" justifyContent="space-between" spacing={2}>
                                                        <Typography sx={{ fontWeight: 700 }}>
                                                            {(e?.action || "update").toString()}
                                                        </Typography>
                                                        <Typography sx={{ fontSize: "0.9rem" }} color="text.secondary">
                                                            {e?.date ? new Date(e.date).toLocaleString() : "—"}
                                                        </Typography>
                                                    </Stack>

                                                    <Typography sx={{ mt: 0.5, fontSize: "0.92rem" }}>
                                                        {(e?.givenName || "").toString()}{" "}
                                                        {(e?.familyName || "").toString()}
                                                        {e?.email ? ` • ${e.email}` : ""}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Stack>
                                    )}
                                </Paper>
                            ))}
                        </Stack>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeHistory}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={commOpen} onClose={closeCommHistory} fullWidth maxWidth="md">
                <DialogTitle>
                    Communication History
                    {commPatient?.first_name && commPatient?.last_name
                        ? ` • ${commPatient.first_name} ${commPatient.last_name}`
                        : ""}
                </DialogTitle>

                <DialogContent dividers>
                    {commLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                            <CircularProgress />
                        </Box>
                    ) : commError ? (
                        <Typography color="error">{commError}</Typography>
                    ) : commRows.length === 0 ? (
                        <Typography color="text.secondary">No communication history found.</Typography>
                    ) : (
                        <Table size="small" sx={{ "& th": { fontWeight: 800 } }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Method</TableCell>
                                    <TableCell>Patient ID</TableCell>
                                    <TableCell>Topic</TableCell>
                                    <TableCell>Created On</TableCell>
                                    <TableCell>Created By</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {commRows.map((r) => (
                                    <TableRow key={r?.id || `${r?.patient_id}-${r?.created_on}`}>
                                        <TableCell>{r?.method ?? "—"}</TableCell>
                                        <TableCell>{r?.patient_id ?? "—"}</TableCell>
                                        <TableCell>{r?.topic ?? "—"}</TableCell>
                                        <TableCell>{fmtDateTime(r?.created_on)}</TableCell>
                                        <TableCell>{formatCommCreatedBy(r?.created_by)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeCommHistory}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={proxyInfoOpen}
                onClose={proxySaveLoading ? undefined : closeProxyInfoDialog}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    {proxyDialogMode === "create"
                        ? "Add Proxy Contact Information"
                        : "Proxy / POA Contact Information"}
                    {proxyInfoPatient?.first_name && proxyInfoPatient?.last_name
                        ? ` • ${proxyInfoPatient.first_name} ${proxyInfoPatient.last_name}`
                        : ""}
                </DialogTitle>

                <DialogContent dividers>
                    {proxySaveMsg.open && (
                        <Alert
                            severity={proxySaveMsg.severity}
                            sx={{ mb: 2 }}
                            onClose={() => setProxySaveMsg({ open: false, severity: "info", text: "" })}
                        >
                            {proxySaveMsg.text}
                        </Alert>
                    )}

                    {proxyDialogMode === "view" ? (
                        <Stack spacing={1.25}>
                            <Typography>
                                <strong>Name:</strong>{" "}
                                {[proxyFirstName, proxyLastName].filter(Boolean).join(" ") || "—"}
                            </Typography>

                            <Typography>
                                <strong>Relationship:</strong> {proxyRelationship || "—"}
                            </Typography>

                            <Typography>
                                <strong>Email:</strong> {proxyEmail || "—"}
                            </Typography>

                            <Typography>
                                <strong>Phone:</strong> {proxyPhone || "—"}
                            </Typography>

                            <Typography>
                                <strong>Phone Type:</strong>{" "}
                                {getProxyInfoFromLatestConsent(proxyInfoPatient?.consent_latest)?.phone_number_type ||
                                    (getProxyInfoFromLatestConsent(proxyInfoPatient?.consent_latest)?.mobile_phone
                                        ? "Mobile"
                                        : getProxyInfoFromLatestConsent(proxyInfoPatient?.consent_latest)?.landline
                                            ? "Landline"
                                            : "—")}
                            </Typography>
                        </Stack>
                    ) : (
                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ textAlign: "center", fontWeight: 700 }}>
                                Proxy/Designee Details
                            </Typography>

                            <TextField
                                label="Proxy / Designee First Name"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={proxyFirstName}
                                onChange={(e) => setProxyFirstName(e.target.value)}
                            />

                            <TextField
                                label="Proxy / Designee Last Name"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={proxyLastName}
                                onChange={(e) => setProxyLastName(e.target.value)}
                            />

                            <TextField
                                label="Proxy / Designee Email"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={proxyEmail}
                                onChange={(e) => setProxyEmail(e.target.value)}
                            />

                            <TextField
                                label="Proxy / Designee Phone Number"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={proxyPhone}
                                onChange={(e) => setProxyPhone(digitsOnly(e.target.value))}
                                helperText="Enter 10 digits to verify line type."
                                inputProps={{ inputMode: "numeric" }}
                                onBlur={() => {
                                    const digits = digitsOnly(proxyPhone);
                                    if (digits.length === 10 && proxyLastCheckedRef.current !== digits) {
                                        proxyLastCheckedRef.current = digits;
                                        doProxyLineTypeCheck(digits);
                                    }
                                }}
                            />

                            <div style={{ marginTop: 8 }}>
                                {proxyLineCheck.status === "checking" && (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <CircularProgress size={16} />
                                        <Typography variant="body2">Checking phone line type…</Typography>
                                    </Box>
                                )}
                                {proxyLineCheck.status === "ok" && <Alert severity="success">{proxyLineCheck.message}</Alert>}
                                {proxyLineCheck.status === "bad" && <Alert severity="warning">{proxyLineCheck.message}</Alert>}
                                {proxyLineCheck.status === "error" && <Alert severity="error">{proxyLineCheck.message}</Alert>}
                            </div>

                            <TextField
                                select
                                label="Proxy / Designee Relationship"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                value={proxyRelationship}
                                onChange={(e) => setProxyRelationship(e.target.value)}
                            >
                                <MenuItem value="MPOA">Medical Power of Attorney (MPOA)</MenuItem>
                                <MenuItem value="HCP">Medical Health Care Proxy (HCP)</MenuItem>
                                <MenuItem value="Conservator">Conservator</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                            </TextField>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeProxyInfoDialog} disabled={proxySaveLoading}>
                        {proxyDialogMode === "view" ? "Close" : "Cancel"}
                    </Button>
                    {proxyDialogMode === "create" && (
                        <Button
                            variant="contained"
                            onClick={handleSaveProxyInfo}
                            disabled={proxySaveLoading || proxyLineCheck.status === "checking"}
                        >
                            {proxySaveLoading ? "Saving..." : "Save"}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

            <Dialog open={historyProxyOpen} onClose={closeHistoryProxyDialog} fullWidth maxWidth="sm">
                <DialogTitle>Historical Proxy / POA Contact Information</DialogTitle>

                <DialogContent dividers>
                    {!historyProxyInfo ? (
                        <Typography color="text.secondary">No proxy / POA contact info found for this record.</Typography>
                    ) : (
                        <Stack spacing={1.25}>
                            <Typography>
                                <strong>Source:</strong>{" "}
                                {historyProxyInfo?.source === "external_form"
                                    ? "Linked External Form"
                                    : "Proxy Record"}
                            </Typography>

                            <Typography>
                                <strong>Name:</strong>{" "}
                                {[historyProxyInfo?.first_name, historyProxyInfo?.last_name]
                                    .filter(Boolean)
                                    .join(" ") || "—"}
                            </Typography>

                            <Typography>
                                <strong>Relationship:</strong> {historyProxyInfo?.relationship || "—"}
                            </Typography>

                            <Typography>
                                <strong>Email:</strong> {historyProxyInfo?.email || "—"}
                            </Typography>

                            <Typography>
                                <strong>Mobile Phone:</strong> {historyProxyInfo?.mobile_phone || "—"}
                            </Typography>

                            <Typography>
                                <strong>Landline:</strong> {historyProxyInfo?.landline || "—"}
                            </Typography>

                            {historyProxyInfo?.phone_number_type ? (
                                <Typography>
                                    <strong>Phone Type:</strong> {historyProxyInfo.phone_number_type}
                                </Typography>
                            ) : null}
                        </Stack>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeHistoryProxyDialog}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={resetOpen} onClose={resetLoading ? undefined : closeResetDialog} fullWidth maxWidth="sm">
                <DialogTitle>
                    Reset Consent Status
                    {resetPatient?.first_name && resetPatient?.last_name
                        ? ` • ${resetPatient.first_name} ${resetPatient.last_name}`
                        : ""}
                </DialogTitle>

                <DialogContent dividers>
                    <Stack spacing={2}>
                        {resetError && <Alert severity="error">{resetError}</Alert>}
                        {resetResult && <Alert severity="success">{resetResult}</Alert>}

                        <Box
                            sx={{
                                border: "1px solid #e5e7eb",
                                borderRadius: 2,
                                p: 2,
                                backgroundColor: resetChoice === "erroneous" ? "#f5faff" : "#fff",
                            }}
                        >
                            <Typography sx={{ fontWeight: 700 }}>
                                Would you like to archive this record?
                            </Typography>
                            <Typography sx={{ color: "text.secondary", mt: 0.5, mb: 1.5 }}>
                                This will mark only the latest consent record inactive and archive the entry.
                                {resetHistoryCount > 1
                                    ? ` The patient will then revert to the previous consent status: ${erroneousResetNextStatus}.`
                                    : " No earlier consent record exists, so the patient will become Pending."}
                            </Typography>

                            {resetPatient?.consent_latest?.id && (
                                <>
                                    <Typography sx={{ fontSize: "0.9rem", color: "text.secondary" }}>
                                        Latest Consent Status: {resetPatient?.consentStatusLabel || "—"}
                                    </Typography>
                                    <Typography sx={{ fontSize: "0.9rem", color: "text.secondary" }}>
                                        Status After Reset: {erroneousResetNextStatus}
                                    </Typography>
                                </>
                            )}

                            <Button
                                sx={{ mt: 2 }}
                                variant={resetChoice === "erroneous" ? "contained" : "outlined"}
                                onClick={() => {
                                    setResetChoice("erroneous");
                                    setResetError("");
                                    setResetResult("");
                                }}
                                disabled={resetLoading || !!resetResult}
                            >
                                Choose This Option
                            </Button>
                        </Box>

                        <Box
                            sx={{
                                border: "1px solid #e5e7eb",
                                borderRadius: 2,
                                p: 2,
                                backgroundColor: resetChoice === "opt-out" ? "#f5faff" : "#fff",
                            }}
                        >
                            <Typography sx={{ fontWeight: 700 }}>
                                {resetConsentQuestion}
                            </Typography>
                            <Typography sx={{ color: "text.secondary", mt: 0.5, mb: 1.5 }}>
                                Continue through the consent workflow to record the {resetConsentDirection}.
                            </Typography>

                            <Button
                                variant={resetChoice === "opt-out" ? "contained" : "outlined"}
                                onClick={() => {
                                    setResetChoice("opt-out");
                                    setResetError("");
                                    setResetResult("");
                                }}
                                disabled={resetLoading || !!resetResult}
                            >
                                Choose This Option
                            </Button>

                            {resetChoice === "opt-out" && (
                                <Box
                                    sx={{
                                        mt: 2,
                                        p: 2,
                                        borderRadius: 2,
                                        border: "1px solid #dbe5f0",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 700, mb: 1.5 }}>
                                        Do you have a PDF to upload for this {resetConsentDirection}?
                                    </Typography>

                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                                        <Button
                                            variant="contained"
                                            onClick={() => openResetConsentModal("upload")}
                                            disabled={resetLoading}
                                        >
                                            Yes
                                        </Button>

                                        <Button
                                            variant="outlined"
                                            onClick={() => openResetConsentModal("verbal")}
                                            disabled={resetLoading}
                                        >
                                            No
                                        </Button>
                                    </Stack>
                                </Box>
                            )}
                        </Box>
                    </Stack>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeResetDialog} disabled={resetLoading}>
                        {resetResult ? "Close" : "Cancel"}
                    </Button>

                    {!resetResult && resetChoice === "erroneous" && (
                        <Button
                            variant="contained"
                            onClick={openResetConfirmDialog}
                            disabled={resetLoading}
                        >
                            {resetLoading ? "Submitting..." : "Submit Archive"}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

            <Dialog
                open={resetConfirmOpen}
                onClose={resetLoading ? undefined : closeResetConfirmDialog}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Confirm Archive Consent Record</DialogTitle>
                <DialogContent dividers>
                    <Typography>Are you sure you want to archive the latest consent record?</Typography>

                    <Typography sx={{ mt: 2, color: "text.secondary", fontSize: "0.95rem" }}>
                        {resetHistoryCount > 1
                            ? `The patient will return to the previous status: ${erroneousResetNextStatus}.`
                            : "No previous consent record exists, so the patient status will become Pending."}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeResetConfirmDialog} disabled={resetLoading}>
                        No
                    </Button>
                    <Button variant="contained" onClick={submitResetConsent} disabled={resetLoading}>
                        Yes, Archive
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={resendMsg.open} onClose={closeResendMsg} fullWidth maxWidth="xs">
                <DialogTitle>Resend Consent</DialogTitle>
                <DialogContent dividers>
                    <Typography color={resendMsg.severity === "error" ? "error" : "text.primary"}>
                        {resendMsg.text}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeResendMsg}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={initiateProxyConfirmOpen}
                onClose={closeInitiateNewProxyConfirm}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Initiate New Proxy</DialogTitle>

                <DialogContent dividers>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        Initiating a new proxy will deactivate the current proxy/POA information for this patient.
                    </Alert>

                    <Typography sx={{ fontWeight: 700, mb: 1 }}>
                        Current Proxy / POA Information
                    </Typography>

                    {(() => {
                        const proxyInfo = getProxyInfoFromLatestConsent(
                            initiateProxyPatient?.consent_latest
                        );

                        if (!proxyInfo) {
                            return (
                                <Typography color="text.secondary">
                                    No current proxy / POA information was found for this patient.
                                </Typography>
                            );
                        }

                        const fullName = [
                            proxyInfo?.first_name,
                            proxyInfo?.last_name,
                        ]
                            .filter(Boolean)
                            .join(" ");

                        return (
                            <Stack spacing={1.25}>
                                <Typography>
                                    <strong>Name:</strong> {fullName || "—"}
                                </Typography>

                                <Typography>
                                    <strong>Relationship:</strong> {proxyInfo?.relationship || "—"}
                                </Typography>

                                <Typography>
                                    <strong>Email:</strong> {proxyInfo?.email || "—"}
                                </Typography>

                                <Typography>
                                    <strong>Mobile Phone:</strong> {proxyInfo?.mobile_phone || "—"}
                                </Typography>

                                <Typography>
                                    <strong>Landline:</strong> {proxyInfo?.landline || "—"}
                                </Typography>

                                <Typography>
                                    <strong>Phone Type:</strong>{" "}
                                    {proxyInfo?.phone_number_type ||
                                        (proxyInfo?.mobile_phone
                                            ? "Mobile"
                                            : proxyInfo?.landline
                                                ? "Landline"
                                                : "—")}
                                </Typography>
                            </Stack>
                        );
                    })()}

                    <Typography sx={{ mt: 2, color: "text.secondary" }}>
                        Do you want to continue and initiate a new proxy?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeInitiateNewProxyConfirm}>
                        No
                    </Button>

                    <Button variant="contained" onClick={confirmInitiateNewProxy}>
                        Yes, Continue
                    </Button>
                </DialogActions>
            </Dialog>

            <BatchDownloadPdfsModal
                open={batchDownloadPdfsOpen}
                onClose={closeBatchDownloadPdfsModal}
                patientIds={batchDownloadPatientIds}
                facilityName={facility_name}
                token={kc?.token}
            />

            <ConsentModal
                isOpen={consentOpen}
                onClose={closeConsentModal}
                onSuccess={handleConsentSuccess}
                mode={consentMode}
                context={consentContext}
            />
        </Box>
    );
};

export default ConsentPatientView;

